import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { GetPastSurveyCacheKey } from '../queries/useGetPastSurveys';

export const deleteSurvey = async (teamId: number, surveyId: number) => {
  return axios.delete(`/api/surveys/${teamId}/${surveyId}`);
};

export const useDeleteSurvey = (teamId: number) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ teamId, surveyId }: { teamId: number; surveyId: number }) =>
      deleteSurvey(teamId, surveyId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [GetPastSurveyCacheKey.PastSurvey, teamId],
      });
    },
  });
};
